/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import { COMPONENT_PREVIEW_INPUT_TYPE_INLINE } from '../ComponentPreviewFunctionInputData.entity.constant';

/**
 * The dxp component preview function inline input data entity type.
 * @export
 */
export type EntityComponentPreviewFunctionInlineInput = io.TypeOf<typeof ComponentPreviewFunctionInlineInput>;

/**
 * The dxp component preview function inline input data entity definition.
 * @export
 */
export const ComponentPreviewFunctionInlineInput = io.type(
  {
    type: io.literal(COMPONENT_PREVIEW_INPUT_TYPE_INLINE),
    value: io.UnknownRecord,
  },
  `ComponentPreviewFunctionInlineInput`,
);
